import { render, staticRenderFns } from "./MediationPlanModule.vue?vue&type=template&id=28df6b16&"
import script from "./MediationPlanModule.vue?vue&type=script&lang=js&"
export * from "./MediationPlanModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports